import React from 'react'
import find from 'lodash/find'
import isEmpty from 'lodash/isEmpty'
import first from 'lodash/first'
import keys from 'lodash/keys'
import { ButtonGroup, Dropdown } from 'react-bootstrap'
import type { ListField } from '@ztechapps/common.hook'
import { DirectionEnum } from '@ztechapps/common.contract'
import { useDeepCompareEffect } from '@ztechapps/common.hook'
import { humanize, truncate } from '@ztechapps/common.utils'
import { BusyButton } from '@ztechapps/webui.button'
import { useContext } from '../Context'

const getDisplayName = (activeSortField) => {
  const { displayName, name } = activeSortField ?? {}

  let result = displayName
  if (!displayName) result = humanize(name)

  return result
}

export const SortButton = ({ onSort }) => {
  const { commonFields, sort = {}, loading } = useContext()
  const fields = commonFields.sortFields

  const [direction, setDirection] = React.useState(DirectionEnum.asc)
  const [activeSortField, setActiveSortField] = React.useState(fields?.[0])

  useDeepCompareEffect(() => {
    const sortFieldName = first(keys(sort))
    if (isEmpty(sortFieldName)) return

    const initialActiveSortField = find(fields, { name: sortFieldName })

    //the equality is intentional not teh typesafe, because it gets value from storage, and might be string or number which is fine
    // eslint-disable-next-line
    const initialSortDirection = sort[sortFieldName] == 1 ? DirectionEnum.asc : DirectionEnum.desc

    setDirection(initialSortDirection)
    setActiveSortField(initialActiveSortField)
  }, [sort])

  const onButtonClick = () => {
    //set teh direction
    const _direction = direction === DirectionEnum.asc ? DirectionEnum.desc : DirectionEnum.asc
    setDirection(_direction)

    //call the actual sort function
    onSort({ direction: _direction, activeSortField })
  }

  const onMenuClick = (field: ListField) => {
    //set the active sort fields
    setActiveSortField(field)

    //call the actual sort function
    onSort({ direction, activeSortField: field })
  }

  const icon = direction?.toLowerCase?.() === DirectionEnum.asc ? 'sort-alpha-asc' : 'sort-alpha-desc'
  const buttonText = truncate(getDisplayName(activeSortField), 20)

  return (
    <Dropdown align="end" as={ButtonGroup}>
      <BusyButton icon={icon} text={buttonText} onClick={onButtonClick} disabled={loading} />

      <Dropdown.Toggle variant="primary" disabled={loading} />
      <Dropdown.Menu>
        {fields &&
          fields.map((m) => (
            <Dropdown.Item
              onClick={() => onMenuClick(m)}
              active={m?.name === activeSortField?.name}
              key={getDisplayName(m)}
            >
              {getDisplayName(m)}
            </Dropdown.Item>
          ))}
      </Dropdown.Menu>
    </Dropdown>
  )
}
